import {createAction, createReducer} from '@reduxjs/toolkit';

interface UserState {
    accessToken: string | null;
    contactId: number | null;
}

const initialState: UserState = {
    accessToken: null,
    contactId: null
};

export const setToken = createAction<string | null>('SET_TOKEN');
export const setContactId = createAction<number | null>('SET_CONTACT_ID');

const userReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setToken, (state, action) => {
            state.accessToken = action.payload;
        })
        .addCase(setContactId, (state, action) => {
            state.contactId = action.payload;
        })
});
export default userReducer;